import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/**
 * Whether this deployment can take cards. Asked once and cached, so screens can
 * hide the card buttons rather than offering something that answers 503.
 */
export function usePaymentsStatus(): { cardsAccepted: boolean; loading: boolean } {
  const status = useQuery({
    queryKey: ["payments-status"],
    queryFn: () => api<{ cardsAccepted: boolean }>("/api/v1/admin/payments/status"),
    staleTime: Infinity,
  });

  return { cardsAccepted: status.data?.cardsAccepted ?? false, loading: status.isPending };
}

/**
 * The address a buyer opens. Defaults to wherever this app is served from,
 * because that is the app serving the page — a link copied from a screen has to
 * point at a page that screen's own deployment actually has.
 */
export function checkoutUrlFor(token: string): string {
  const configured = import.meta.env["VITE_CHECKOUT_URL"] as string | undefined;
  const origin = configured ?? window.location.origin;
  return `${origin.replace(/\/$/, "")}/pay/${token}`;
}
